// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CUMIe","toggle":"styles_toggle__2W2oj","preview":"styles_preview__1TRqP"};